export const ENV = {
  PRODUCTION: false,
  NAME: "staging",
  CAS: {
    DOMAIN: 'https://casi.cwsfirabarcelona.com/login',
    CSS_URL: 'https://stg-mediarepository.cwsfirabarcelona.com/shows/backoffice/css/cas.css',
    LANG: 'es',
    SERVICE: 'http://ecatalogue-backofficestg.cwsfirabarcelona.com/login',
    LOGOUT: 'https://casi.cwsfirabarcelona.com/logout'
  },
  APP: {
    FRONTEND_URL: 'https://ecatalogue-backofficestg.cwsfirabarcelona.com',
    BACKEND_API: 'https://ecataloguestg-api.cwsfirabarcelona.com/v1',
    USEARCH_API: 'https://ecatalogueusearchstg-api.cwsfirabarcelona.com/v1',
    FRONTOFFICE_URL: 'https://ecataloguestg.cwsfirabarcelona.com',
    STORAGE_REPOSITORY: 'https://stg-ecatalogue-data.s3.eu-west-1.amazonaws.com',
    MEDIA_API: 'https://mediai.cwsfirabarcelona.com/v1'
  },
  BASE_PATH: {
    USERS: 'https://usersi.cwsfirabarcelona.com/v1',
    DIGPLATFORM: 'https://registration-digitalplatformstg-api.cwsfirabarcelona.com'
  },
  MAPS: {
    BASE_URI: "https://mapsstg.cwsfirabarcelona.com/ecatalogue",
    BASE_VISOR_URI: "https://visorstg.cwsfirabarcelona.com"
  },
  MOCKS: false,
  MOCKS_BASE_PATH: 'http://localhost:3000',
  STORAGE_REPOSITORY: 'https://stg-ecatalogue-data.s3.eu-west-1.amazonaws.com',
  CAPTCHA: {
    SITEKEY: '6LcJQRwmAAAAAK9-tyn-vrnlXqJh3NXYnikdQUiV',
    USER: "firabarcelona.captcha@gmail.com",
    PASSWORD: "Fira2023*"
  },
  REGISTRATION_FRONTOFFICE_URL: "https://registration-frontofficestg.cwsfirabarcelona.com/#"
};
